// progress.js — welliger Fortschritt (M3 Expressive). Gibt ein SVG-Element zurück; value 0..1 oder null (unbestimmt).
const NS = 'http://www.w3.org/2000/svg';

/** Pfad einer Sinuswelle über die Breite w (Wellenlänge lambda, Amplitude amp, Mitte y). */
export function wavePath(w, { lambda = 40, amp = 3, y = 7 } = {}) {
  const k = (2 * Math.PI) / lambda;
  let d = `M0 ${y}`;
  for (let x = 2; x <= w + lambda; x += 2) d += ` L${x} ${(y - amp * Math.sin(k * x)).toFixed(2)}`;
  return d;
}

export function wavyProgress({ value = null, label = '' } = {}) {
  const svg = document.createElementNS(NS, 'svg');
  svg.setAttribute('class', 'vc-wavy' + (value == null ? ' is-indeterminate' : ''));
  svg.setAttribute('role', 'progressbar');
  if (label) svg.setAttribute('aria-label', label);
  svg.setAttribute('aria-valuemin', '0'); svg.setAttribute('aria-valuemax', '100');
  const g = document.createElementNS(NS, 'g');
  const track = document.createElementNS(NS, 'line');
  track.setAttribute('class', 'vc-wavy-track'); track.setAttribute('y1', '7'); track.setAttribute('y2', '7');
  track.setAttribute('stroke-width', '4'); track.setAttribute('stroke-linecap', 'round');
  const wave = document.createElementNS(NS, 'path');
  wave.setAttribute('class', 'vc-wavy-active vc-wavy-wave');
  wave.setAttribute('fill', 'none'); wave.setAttribute('stroke-width', '4'); wave.setAttribute('stroke-linecap', 'round');
  g.append(track, wave); svg.append(g);
  let v = value;
  const draw = () => {
    const w = svg.clientWidth || 200;
    svg.setAttribute('viewBox', `0 0 ${w} 14`);
    wave.setAttribute('d', wavePath(w));
    svg.style.setProperty('--_w', String(w));
    if (v == null) {
      track.setAttribute('x1', '0'); track.setAttribute('x2', String(w));
      wave.style.strokeDasharray = `${w * 0.35} ${w * 2}`; wave.style.strokeDashoffset = '0';
      svg.removeAttribute('aria-valuenow');
    } else {
      const len = wave.getTotalLength ? wave.getTotalLength() : w * 1.1;
      const frac = Math.max(0, Math.min(1, v));
      const xEnd = w * frac;
      track.setAttribute('x1', String(Math.min(w, xEnd + 8))); track.setAttribute('x2', String(w));
      track.style.display = frac >= 1 ? 'none' : '';
      wave.style.strokeDasharray = `${len} ${len}`;
      wave.style.strokeDashoffset = String(len - len * (xEnd / (w + 40)));
      svg.setAttribute('aria-valuenow', String(Math.round(frac * 100)));
    }
  };
  if (typeof ResizeObserver !== 'undefined') new ResizeObserver(draw).observe(svg);
  queueMicrotask(draw);
  svg.setValue = (nv) => { v = nv; svg.classList.toggle('is-indeterminate', nv == null); draw(); };
  return svg;
}
